<template>
  <ul class="poi-select-group__wrap" v-show="visible">
    <li class="poi-select-group__title">{{ label }}</li>
    <li>
      <ul class="poi-select-group">
        <slot></slot>
      </ul>
    </li>
  </ul>
</template>

<script type="text/babel">
  import Emitter from '../../../../assets/js/mixins/emitter';

  export default {
    mixins: [Emitter],

    name: 'poi-option-group',

    componentName: 'poi-option-group',

    props: {
      label: String,
      disabled: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        visible: true
      };
    },

    watch: {
      disabled(val) {
        this.broadcast('poi-option', 'handleGroupDisabled', val);
      }
    },

    methods: {
      queryChange() {
        this.visible = this.$children &&
          Array.isArray(this.$children) &&
          this.$children.some(option => option.visible === true);
      }
    },

    created() {
      this.$on('queryChange', this.queryChange);
    },

    mounted() {
      if (this.disabled) {
        this.broadcast('poi-option', 'handleGroupDisabled', this.disabled);
      }
    }
  };
</script>
